module.exports = __webpack_public_path__ + "img/Treasure-ball-min.9df73abe.png";